import { IReactChildrenOnly } from "@custom-types/types";
import { Badge, SxProps } from "@mui/material";
import { colorConst } from "@styles/common-colors";

interface Props extends IReactChildrenOnly {
  /** Optional sx properties to override the badge style. */
  sx?: SxProps;
}

/**
 * An orange badge with a dot to show that something is new.
 */
export function NewBadge({ children, sx } : Props): JSX.Element {
  return (
    <Badge
      variant="dot"
      color="primary"
      sx={{
        height: "24px",
        width: "24px",
        "& .MuiBadge-dot": {
          backgroundColor: colorConst.newFeatureIndicator,
          height: "10px",
          width: "10px",
          borderRadius: "50%",
        },
        ...sx,
      }}
    >
      {children}
    </Badge>
  );
}
